import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Grid from '@material-ui/core/Grid'
import useTheme from '@material-ui/core/styles/useTheme'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import LazyLoadedVideo from '../../Videos/LazyLoadedVideo'
import { useMediaQuery } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    videoModal: {
        maxWidth: '100%',
        maxHeight: '100%',
        width: '300px',
        height: '200px',
        [theme.breakpoints.up('md')]: {
            width: '400px',
            height: '300px',
        },
    },
}))

const GreetingCardVideoModal = (props) => {
    const { modalIsOpen } = props
    const classes = useStyles()
    const theme = useTheme()

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    })

    return (
        <React.Fragment>
            <Dialog
                id="greeting-card-image-modal"
                maxWidth={'lg'}
                open={modalIsOpen}
                onClose={props.closeModal}
                aria-labelledby="Greeting Card"
            >
                <DialogTitle id="max-width-dialog-title">
                    <IconButton
                        data-testid="close-button"
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={props.closeModal}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        spacing={2}
                        style={{
                            padding: '.25rem',
                        }}
                    >
                        <Grid item xs={12}>
                            <Grid
                                container
                                className={classes.videoModal}
                                alignItems="center"
                                justify="center"
                            >
                                <LazyLoadedVideo
                                    videoId={'j5yF0yFRRk8'}
                                    width={isMd ? 380 : 250}
                                    height={isMd ? 214 : 141}
                                    thumbnail={'GCG/synthesia/BAC-2.webp'}
                                    thumbnailAlt={
                                        'Synthesia video about build-a-card'
                                    }
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default GreetingCardVideoModal
